import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const resetPasswordSlice = createSlice({
  name: "resetPasswordSlice",
  initialState: {
    message: undefined,
    dataFetchingStatus: false,
  },
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
  },
});

export const { setDataFetchingStatus, setMessage } = resetPasswordSlice.actions;

export const resetPasswordRequest = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setMessage(undefined));
  axios
    .post("/resetpassword", data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setMessage(error.response.data.error));
    });
};

export default resetPasswordSlice.reducer;
